import './css/DoorPositioning.css'
import defaultdoor from './config/defaultdoor.json'
//import defaultwall from './config/defaultwall.json'

const DoorPositioning = (props)=> {

    const a = Object.keys(props.doors).includes('a');
    const b = Object.keys(props.doors).includes('b');
    const c = Object.keys(props.doors).includes('c');

    const setDoor = (side,enable)=>{
        let newconfig = JSON.parse(JSON.stringify(props.doors));
        if( ! enable )
            delete newconfig[side]
        else
            if( !newconfig[side] )
                newconfig[side] = defaultdoor;
        if( JSON.stringify(newconfig) !== JSON.stringify(props.doors) )
            props.update(JSON.stringify(newconfig), props.floor);
    }

    return (
        <div className='door-positioning bg-leggera' >
            <div className='info'>Select doors position</div>
            <div className='door-container'>
                <div className={`door-side door-side-a ${a?'select':''}`} data-item='a' onClick={()=>setDoor('a',!a)}>A</div>
                <div className={`door-side door-side-b ${b?'select':''}`} data-item='b' onClick={()=>setDoor('b',!b)}>B</div>
                <div className={`door-side door-side-c ${c?'select':''}`} data-item='c' onClick={()=>setDoor('c',!c)}>C</div>
            </div>
        </div>
    )
}

export default DoorPositioning;